import Classes from './SlideCard.module.scss';
import {Link} from 'react-router-dom';
import {useMixContext} from '../../../context/MixContext';

type slideCard = {
    title: string,
    imgSrc: string,
    slug: string,
    sticker: boolean,
    filePath: string
}
const SlideCard = (props: any) => {
    const {title, imgSrc, sticker, slug, filePath}: slideCard = props;
    const {setRelatedGifCount} = useMixContext();
    return (
        <Link
            to={sticker ? `/gif/${encodeURIComponent(slug)}/${encodeURIComponent(filePath?.replace('resources/', ''))}` : `/category/${slug}`}
            className={`${Classes.slideCardWrap} position-relative ${sticker ? Classes.stickerCard : ''}`}
            state={{...props, catName: title}}
            onClick={() => setRelatedGifCount(0)}
        >
            <img src={`${process.env.REACT_APP_MEDIA_SERVER}/${imgSrc}${process.env.REACT_APP_MEDIA_SERVER === 'https://pub-644af971f0cd4ee9a8afae61e11d51ff.r2.dev' ? '.png' : ''}`} alt={title}/>
            {!sticker && title !== '' ?
                <span
                    className={`${Classes.overlayName} position-absolute d-flex align-items-center justify-content-center`}>
                    {title}
                </span>
                : null
            }
        </Link>
    );
};

export default SlideCard;